import React, { Component } from 'react'
import { translation } from '../../../../utils/helpers'

import Part from './../Part'
import './complaint.scss'

// Elements
import Button from '../../../elements/button'
import PanelHeader from '../../../elements/panelHeader'
import Textarea from '../../../elements/textarea'
import Text from '../../../elements/text'
import LabelWrapper from '../../../elements/labelWrapper'

class Complaint extends Component {
  constructor (props) {
    super(props)
    this.state = {
      comment: '',
      refNr: ''
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.orderpriceSave = this.orderpriceSave.bind(this)
  }

  componentDidMount () {
    this.props.onRef(this)
  }

  componentWillUnmount () {
    this.props.onRef(undefined)
  }

  componentWillReceiveProps (next) {
    if (typeof next.orderPrice !== 'object') return
    if (next.orderPrice.Department === 0) {
      this.setState({
        comment: next.orderPrice.ComplaintComment,
        refNr: next.orderPrice.ComplaintRefNr
      })
    } else {
      this.setState({
        comment: next.orderPrice.BodyShopComplaintComment,
        refNr: next.orderPrice.BodyShopComplaintRefNr
      })
    }
  }

  getTitle () {
    return translation(333)
  }

  getTitleAria () {
    return translation(2705)
  }

  getIcon () {
    return '/images/svgs/ordrer/Complaint-black.svg'
  }

  getEditUrl () {
    if (this.props.orderPrice.Department === 0) {
      return '/pricecalculation/' + this.props.order.Id + '/1'
    } else {
      return '/pricecalculation/' + this.props.order.Id + '/bodyextent'
    }
  }

  onInputChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  orderpriceSave () {
    setTimeout(() => {
      var data = this.props.orderPrice
      if (data.Department === 0) {
        data.ComplaintComment = this.state.comment
        data.ComplaintRefNr = this.state.refNr
      } else {
        data.BodyShopComplaintComment = this.state.comment
        data.BodyShopComplaintRefNr = this.state.refNr
      }
      this.props.saveOrderPrice(data)
    }, 50)
  }

  renderComment () {
    return (
      this.props.editable ? (
        <Textarea
          labelText={translation('149')}
          name={'comment'}
          value={this.state.comment || ''}
          onBlur={this.orderpriceSave}
          onChange={this.onInputChange} />
      ) : (
        <LabelWrapper labelText={translation('149')}>
          <span>{this.state.comment}</span>
        </LabelWrapper>
      )
    )
  }

  renderRefNr () {
    return (
      this.props.editable ? (
        <Text
          labelText={translation('13410')}
          name={'refNr'}
          value={this.state.refNr || ''}
          onBlur={this.orderpriceSave}
          onChange={this.onInputChange} />
      ) : (
        <LabelWrapper labelText={translation('13410')}>
          <span>{this.state.refNr}</span>
        </LabelWrapper>
      )
    )
  }

  onDelete (part, task) {
    if (part && task) {
      part.Complaints.map(x => {
        if (x.ComplaintType === task.ComplaintType) x.IsDeleted = true
        return x
      })

      this.props.orderPrice.Parts.map(x => {
        if (x.Part.TaskSide === part.Part.TaskSide && x.Part.PartItemId === part.Part.PartItemId) x = part
        return x
      })

      this.orderpriceSave()
    }
  }

  render () {
    if (this.props.orderPrice === undefined || this.props.orderPrice === null) return null
    let parts = this.props.orderPrice.Parts

    const goBack = () => {
      this.orderpriceSave
      this.props.goBack()
    }

    let css = ''
    if (this.props.editable) {
      css += 'price__view editable'
    }
    css += ' extent_complaint'

    const renderPart = (part) => {
      return (
        <Part
          key={'part_' + part.Part.PartItemId + '_' + part.Part.TaskSide}
          onDelete={this.props.editable && this.onDelete.bind(this, part)}
          part={part} />
      )
    }

    return (
      <div className={css}>
        <div>
          {this.props.viewMode === 'mobile' && this.props.renderInside()}
          {this.props.editable && <PanelHeader text={translation('304')} />}
          {parts.map(renderPart)}
        </div>
        {this.renderComment()}
        {this.renderRefNr()}
        {this.props.editable && <Button onClick={goBack} labelText={translation('956')} />}
      </div>
    )
  }
}

export default Complaint



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Complaint/index.js